// @flow

import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  avatar: { marginRight: 16 }
}), { index: 1 })